import React from 'react'

const Manual_etiquetar_eliminar_etiquetas_clientes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Etiquetar y eliminar etiquetas de clientes dentro del Dashboard de Clau.io
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo crear, asignar y eliminar etiquetas en los perfiles de clientes dentro de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Etiquetar_y_eliminar_etiquetas_de_clientes_dentro_del_Dashboard_de_Clauio__dcz-Q78SScqCb2bTh5gIxA?as=scrollable"
          className="scribe-iframe-general-93"
          width="100%"
          height="7000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_etiquetar_eliminar_etiquetas_clientes
